import { clsx } from "clsx";

export function LoadingDots({ className }: { className?: string }) {
  return (
    <span className={clsx("loading-dots", "inline-flex", "items-baseline", "text-2xl", "font-bold", className)}>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  );
}
